import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={0} sx={{ p: 4, backgroundColor: '#f9f9f9' }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ mb: 4, fontWeight: 'bold' }}>
          Privacy Policy
        </Typography>

        <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
          Last Updated: December 27, 2025
        </Typography>

        <Box sx={{ '& h2': { mt: 4, mb: 2, fontSize: '1.5rem', fontWeight: 'bold' }, '& p': { mb: 2, lineHeight: 1.8, color: '#333' } }}>
          <Typography variant="h5" component="h2">
            1. Introduction
          </Typography>
          <Typography variant="body1">
            Macronix Document Validation System ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application and website (collectively, the "Service").
          </Typography>

          <Typography variant="h5" component="h2">
            2. Information We Collect
          </Typography>
          <Typography variant="body1">
            We may collect information about you in a variety of ways. The information we may collect on the Service includes:
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            <strong>Personal Data:</strong> Name, email address, phone number, and other identification information you provide.
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            <strong>Location Data:</strong> GPS coordinates and address information collected during field verification activities.
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            <strong>Document Data:</strong> Images, signatures, and documents uploaded for verification purposes.
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            <strong>Device Information:</strong> Device type, operating system, and mobile network information.
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            <strong>Usage Data:</strong> Information about how you interact with our Service.
          </Typography>

          <Typography variant="h5" component="h2">
            3. Use of Your Information
          </Typography>
          <Typography variant="body1">
            We use the information we collect to:
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            • Provide, maintain, and improve our Service
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            • Process verification requests and maintain records
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            • Communicate with you regarding your account or transactions
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            • Respond to your inquiries and provide customer support
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            • Generate analytics and improve service quality
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            • Comply with legal obligations
          </Typography>

          <Typography variant="h5" component="h2">
            4. Disclosure of Your Information
          </Typography>
          <Typography variant="body1">
            We may share your information in the following situations:
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            <strong>Service Providers:</strong> We may share information with third parties who provide services on our behalf (hosting, data analysis, payment processing).
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            <strong>Business Partners:</strong> We may share information with vendors and business partners for verification and processing.
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            <strong>Legal Requirements:</strong> We may disclose information when required by law or in response to legal requests.
          </Typography>

          <Typography variant="h5" component="h2">
            5. Data Security
          </Typography>
          <Typography variant="body1">
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is completely secure.
          </Typography>

          <Typography variant="h5" component="h2">
            6. Your Rights
          </Typography>
          <Typography variant="body1">
            Depending on your location, you may have the following rights:
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            • Right to access your personal data
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            • Right to correct inaccurate data
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            • Right to request deletion of your data
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            • Right to withdraw consent at any time
          </Typography>

          <Typography variant="h5" component="h2">
            7. Retention of Data
          </Typography>
          <Typography variant="body1">
            We will retain your personal data for as long as necessary to fulfill the purposes for which it was collected, including to satisfy any legal, accounting, or reporting requirements.
          </Typography>

          <Typography variant="h5" component="h2">
            8. Contact Us
          </Typography>
          <Typography variant="body1">
            If you have any questions about this Privacy Policy or our privacy practices, please contact us at:
          </Typography>
          <Typography variant="body1" sx={{ ml: 2, mt: 2 }}>
            <strong>Email:</strong> privacy@macronix.com
          </Typography>
          <Typography variant="body1" sx={{ ml: 2 }}>
            <strong>Address:</strong> Macronix Document Validation System
          </Typography>

          <Typography variant="h5" component="h2">
            9. Changes to This Privacy Policy
          </Typography>
          <Typography variant="body1">
            We may update this Privacy Policy from time to time. The updated version will be indicated by an updated "Last Updated" date at the top of this page.
          </Typography>

          <Typography variant="h5" component="h2">
            10. Compliance
          </Typography>
          <Typography variant="body1">
            This Privacy Policy is designed to be compliant with applicable data protection regulations including GDPR, CCPA, and other regional privacy laws.
          </Typography>

          <Box sx={{ mt: 6, pt: 4, borderTop: '1px solid #e0e0e0', backgroundColor: '#f0f0f0', p: 3, borderRadius: 1 }}>
            <Typography variant="caption" sx={{ color: '#666' }}>
              © 2025 Macronix Document Validation System. All rights reserved.
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
